var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdjudicacion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_733_43372",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_733_43372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.61676 7.86701L6.02062 5.27087L6.73342 4.57474L8.61676 6.45807L12.4001 2.69141L13.0962 3.38754L8.61676 7.86701ZM9.21802 15.0259L4.34622 13.6362V14.5516H1.01294V8.16702H5.78726L9.86931 9.67472C10.1719 9.78669 10.4231 9.98476 10.6231 10.2689C10.8231 10.5531 10.9231 10.8867 10.9231 11.2696H12.5898C13.0685 11.2696 13.4595 11.4318 13.7629 11.7561C14.0663 12.0805 14.218 12.508 14.218 13.0388V13.4619L9.21802 15.0259ZM2.01291 13.5516H3.34624V9.16701H2.01291V13.5516ZM9.18469 13.9721L13.1642 12.7388C13.1437 12.5909 13.0794 12.4758 12.9712 12.3933C12.8631 12.3108 12.736 12.2696 12.5898 12.2696H9.42829C9.10521 12.2696 8.80051 12.2484 8.51419 12.2061C8.22787 12.1638 7.94283 12.0935 7.65907 11.9952L6.43854 11.5824L6.75136 10.6234L8.04624 11.0568C8.25905 11.132 8.50307 11.1862 8.77829 11.2196C9.0535 11.2529 9.43512 11.2696 9.92316 11.2696C9.92316 11.1046 9.88598 10.9623 9.81162 10.8427C9.73727 10.723 9.6394 10.6422 9.51802 10.6003L5.61802 9.16701H4.34622V12.6029L9.18469 13.9721Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdjudicacion);
export default __webpack_public_path__ + "static/media/adjudicacion.571d2125272b1396ed2156a01a25aa4f.svg";
export { ForwardRef as ReactComponent };